import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './PodcastButtonsBlock.module.scss'

const APPLE_PODCAST_LINK =
  'https://podcasts.apple.com/us/podcast/crypto-curious/id1590805941'
const GOOGLE_PODCAST_LINK =
  'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5hY2FzdC5jb20vcHVibGljL3Nob3dzL2NyeXB0by1jdXJpb3Vz'
const SPOTIFY_LINK = 'https://open.spotify.com/show/3yc5YVwkZZXgWPQgae1pGp'
const CRYPTO_CURIOUS_LINK = 'https://www.youtube.com/@cryptocuriouspodcast'
function PodcastButtonsBlock({ className }) {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <a href={APPLE_PODCAST_LINK} target="_blank" rel="noopener noreferrer">
        <StaticImage
          src="../../assets/new-icons/App_Apple.svg"
          alt="Crypto curious Apple Podcasts"
          width={195}
        />
      </a>
      <a href={CRYPTO_CURIOUS_LINK} target="_blank" rel="noopener noreferrer">
        <StaticImage
          src="../../assets/new-icons/Listen_On-YouTube.png"
          alt="Crypto curious Podcasts"
          width={192}
          objectFit="scale-down"
          style={{ borderRadius: '7px' }}
        />
      </a>
      <a href={SPOTIFY_LINK} target="_blank" rel="noopener noreferrer">
        <StaticImage
          src="../../assets/new-icons/App_Spotify.svg"
          alt="Crypto curious Spotify Podcasts"
          width={195}
        />
      </a>
    </div>
  )
}

PodcastButtonsBlock.propTypes = {
  className: PropTypes.string,
}

export default PodcastButtonsBlock
